require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/es6.array.species.js
// module id = ZpMd
// module chunks = 0 3